

import { RootState } from "../store";
import { IAuthState } from "./types";

export const authSelector = (state: RootState): IAuthState => state.auth;

export const accessTokenSelector = (state: RootState): string | null => state.auth.accessToken;

export const phoneSelector = (state: RootState): string | null => state.auth.phone;

